import { useEffect, useRef, useState } from 'react';

export const useWebSocket = (onMessageCallback) => {
  const onMessageRef = useRef(onMessageCallback);
  useEffect(() => {
    onMessageRef.current = onMessageCallback;
  }, [onMessageCallback]);

  const [socketInstance, setSocketInstance] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const API_BASE_URL = process.env.REACT_APP_API_URL_FOR_WS || 'localhost:4000';
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const fullUrl = `${protocol}://${API_BASE_URL}`;

    const socket = new WebSocket(fullUrl);

  socket.onopen = () => {
    console.log('🟢 WebSocket connected');
    console.log('🟢 [useWebSocket] connected to:', socket.url);
    setIsReady(true);
  };

  socket.onmessage = (event) => {
    console.log('🔥 RAW SOCKET MESSAGE:', event.data);  // You should see this
    onMessageRef.current?.(event); // Fire whatever the user wants
  };

  socket.onerror = (err) => console.error('🔴 WebSocket error:', err);
  socket.onclose = () => console.log('⚫ WebSocket closed');

  setSocketInstance(socket);

  return () => {
    socket.close();
    setSocketInstance(null);
    setIsReady(false);
  };
}, [onMessageCallback]);

  const sendMessage = (type, payload) => {
    const message = JSON.stringify({ type, payload });
    if (socketInstance?.readyState === WebSocket.OPEN) {
      socketInstance.send(message);
    } else {
      console.warn('WebSocket not open. Cannot send message.');
    }
  };

  return { socket: socketInstance, sendMessage, isReady };
};
